import { FormFieldBase, FormFieldType } from "src/app/common/components/dynamic-form-field/components/dynamic-form-light/models/form-field-base";
import { TipoTipologica } from "src/app/common/models/tipologiche/tipo-tipologica";

export const questionsBasic = (campi: Array<string>, questions) => {
  let newArray = [...questions];
  let fields: FormFieldBase[] = [
    {
      id: null,
      controlType: FormFieldType[FormFieldType.DROPDOWN],
      key: "modalitaFormazioneDocumento",
      label: "Modalità formazione documento",
      placeholder: "Scegli modalità formazione documento",
      chips: false,
      options: [
        { id: "A", label: "A - Creazione tramite l’utilizzo di strumenti software", value: "A" },
        { id: "B", label: "B - Acquisizione di un documento informatico / acquisizione della copia per immagine/informatica di un documento analogico", value: "B" },
        { id: "C", label: "C - Transazioni o processi informatici o presentazione telematica di dati attraverso moduli o formulari", value: "C" },
        { id: "D", label: "D - Generazione o raggruppamento, anche in via automatica, di un insieme di dati o registrazioni", value: "D" }
      ],
      disabled: false,
      required: true,
      noEmptyOption: true,
      size: "col-sm-5"
    },
    {
      id: null,
      controlType: FormFieldType[FormFieldType.DROPDOWN],
      key: "motivoAssenzaFirma",
      label: "Tipologia firma",
      placeholder: "Scegli tipologia firma",
      chips: false,
      options: [
        { id: "A", label: "Firma omessa ai sensi di legge", value: "A" },
        { id: "B", label: "Privo di firma", value: "B" },
        { id: "C", label: "Copia informatica di originale analogico sottoscritto in forma autografa", value: "C" }
      ],
      disabled: false,
      required: true,
      noEmptyOption: true,
      size: "col-sm-5"
    },
    {
      id: null,
      controlType: FormFieldType[FormFieldType.RADIO],
      key: "documentoUnico",
      label: "Documento Unico",
      chips: false,
      options: [
        { id: "1_si", label: "Sì", value: "Sì" },
        { id: "2_no", label: "No", value: "No" },
      ],
      // value: true,
      disabled: false,
      required: false,
      size: "col-sm-2"
    },
    {
      id: null,
      controlType: FormFieldType[FormFieldType.RADIO],
      key: "tipoUfficioProduttore",
      label: "Tipologia produttore",
      chips: false,
      options: [
        { id: "INTERNO", label: "Interno", value: "INTERNO" },
        { id: "ESTERNO", label: "Esterno", value: "ESTERNO" },
      ],
      // value: true,
      disabled: false,
      required: true,
      size: "col-sm-2"
    },
    {
      id: null,
      controlType: FormFieldType[FormFieldType.TEXT],
      key: "ufficioProduttore",
      label: "Produttore",
      placeholder: "Inserisci produttore",
      chips: false,
      options: null,
      disabled: false,
      required: false,
      size: "col-sm-5"
    },
  ];

  campi.forEach(x => {
    let index = fields.findIndex(el => el.key === x);
    if (index > -1) {
      newArray.push(fields[index]);
    }
  })
  return newArray;

}

export const protocolFields = () => {
  return [
    {
      id: null,
      controlType: FormFieldType[FormFieldType.RADIOMONO],
      key: "primary",
      label: "Primario",
      placeholder: "Scegli primario",
      chips: false,
      // value: true,
      disabled: false,
      required: false,
      size: "col-sm-6"
    },
    {
      id: null,
      controlType: FormFieldType[FormFieldType.DROPDOWN],
      key: "type",
      label: "Tipologia documento",
      placeholder: "Scegli tipologia documento",
      chips: false,
      options: null,
      disabled: false,
      required: true,
      size: "col-sm-6"
    },
  ];
}

export const addDetailFields = () => {
  return [
    {
      id: null,
      controlType: FormFieldType[FormFieldType.TEXT],
      key: "titolo",
      label: "Titolo",
      placeholder: "Inserisci titolo",
      chips: false,
      // value: true,
      disabled: false,
      required: false,
      size: "col-sm-2"
    },
    {
      id: null,
      controlType: FormFieldType[FormFieldType.TEXT],
      key: "ufficioProduttore",
      label: "Produttore copia",
      placeholder: "Inserisci produttore copia",
      chips: false,
      options: null,
      disabled: false,
      required: false,
      size: "col-sm-5"
    },
    {
      id: null,
      controlType: FormFieldType[FormFieldType.TEXT],
      key: "firmatari",
      label: "Firmatario/i",
      placeholder: "Inserisci firmatario/i",
      chips: false,
      options: null,
      disabled: false,
      required: false,
      size: "col-sm-5"
    },
  ];
}


export const FORM_CONFIGURATION: UploadFormTypes = {
  signed: {
    fields: ["tipoUfficioProduttore","ufficioProduttore","modalitaFormazioneDocumento"],
    errors: null,
    icons: [{
      id: "validity-sign",
      label: "glyphicon-ok-sign",
      color: "#009b00",
      tooltip: "Firma valida"
    }],
    hasSign: true,
    signValid: true,
    name: "signed"
  },
  signedNotValid: {
    fields: ["tipoUfficioProduttore","ufficioProduttore", "modalitaFormazioneDocumento"],
    errors: "Firma non valida, certificato scaduto",
    icons: [{
      id: "validity-sign",
      label: "glyphicon-alert",
      color: "#ab0202",
      tooltip: "Firma non valida"
    }],
    hasSign: true,
    signValid: false,
    name: "signedNotValid"
  },
  signedNotValidProtocol: {
    fields: ["tipoUfficioProduttore", "ufficioProduttore","modalitaFormazioneDocumento", ],
    errors: "Firma non valida, certificato scaduto",
    icons: [{
      id: "validity-sign",
      label: "glyphicon-alert",
      color: "#ab0202",
      tooltip: "Firma non valida"
    }],
    hasSign: true,
    signValid: false,
    name: "signedNotValidProtocol"
  },
  notSigned: {
    fields: ["tipoUfficioProduttore","ufficioProduttore","modalitaFormazioneDocumento", "motivoAssenzaFirma"],
    errors: null,
    icons: [],
    hasSign: false,
    signValid: false,
    name: "notSigned"
  },
  archive: {
    fields: ["tipoUfficioProduttore", "ufficioProduttore","modalitaFormazioneDocumento"],
    errors: null,
    icons: [],
    hasSign: false,
    signValid: false,
    name: "archive"
  }
}

export interface UploadFormTypes {
  signed: UploadFormConfiguration,
  signedNotValid: UploadFormConfiguration,
  signedNotValidProtocol: UploadFormConfiguration,
  notSigned: UploadFormConfiguration,
  archive: UploadFormConfiguration
}

export interface UploadFormConfiguration {
  fields: Array<string> | null,
  errors: string | null,
  icons: Array<{id: string;label: string, color: string, tooltip?: string}> | null,
  hasSign: boolean,
  signValid: boolean,
  name: "signed" | "signedNotValid" | "signedNotValidProtocol" | "notSigned" | "archive"
}

export interface DocumentoScansionato {
  titolo?: string;
  produttore?: string;
  firmatari?: string;
}

export interface MetadatoFirmaDocumenti {
  firmaPresente:boolean;
  firmaIntegra:boolean;
  processoCrittograficoCorretto:boolean;
  esitoVerifica: TipoTipologica;
  firmatario: string;
  certificatoCaQualificata:string;
  validitaDataFirma: number;
  tipoFirma: string;
  caEmittente:string;
  identificativoCertificato:string;
  organizzazione: string;
  dataScadenzaFirma: number;
}
 
export interface MetadatoDocumento {
  modalitaFormazioneDocumento?: TipoTipologica;
  motivoAssenzaFirma?: TipoTipologica;
  documentoUnico?: boolean;
  tipoUfficioProduttore?: TipoTipologica;
  ufficioProduttore?: string;
  numDocumentiScansione?: number;
  documentiScansionati?: DocumentoScansionato[];
}
 
